import { Component, OnInit, Input } from '@angular/core';
import { Navbar, NavbarStatus } from '../models/application-models/navbar';
import { NavigationService } from '../services/navigation.service';
import { MainModuleType } from '../models/application-models/main-module-type';
import { OrganisationService } from '../services/organisation.service';
import { LandingModalComponent } from '../landing/landing-modal/landing-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @Input() selectedCentre: MainModuleType;
  centreIndex: number;
  NavbarStatus = NavbarStatus;
  selectedNavbar: Navbar;

  navbarList: Navbar[];

  constructor(
    public navigationService: NavigationService,
    public organisationService: OrganisationService,
    public modalService: NgbModal
  ) { }

  ngOnInit() {
    this.centreIndex = this.navigationService.findCentreIndex(this.selectedCentre);

    if (this.organisationService.organisation && !this.organisationService.organisation.isStagingCentreEnabled) {
      this.navigationService.disableStagingCentreNavigator();
    }

    this.navbarList = this.navigationService.navbarList;
    this.navigationService.selectedNavbar = undefined;
  }

  navClick(navbar?: Navbar){
    let subcategoryFound: Navbar = this.navbarList[this.centreIndex].subCategory.find(subcategory => subcategory === navbar);
    if(!subcategoryFound){
      this.navigationService.navbarStatus = NavbarStatus.MINIMISED;
    } else {
      this.navigationService.selectedNavbar = navbar;
      this.selectedNavbar = navbar;
    }
  }

  openAlertModal(navName: string) {
    const modalRef = this.modalService.open(LandingModalComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.modalRef = modalRef;
    modalRef.componentInstance.centreName = navName;
  }
}
